import React, { useEffect, useState } from "react";
import { History, ArrowDownLeft, ArrowUpRight, FileText, FileSpreadsheet } from "lucide-react";
import { API } from "./api";

const eur = (v) => Number(v || 0).toLocaleString("fr-FR") + " €";
const fmtDate = (s) => {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return "—"; }
};

export default function MemberPaymentsHistory() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/member/comandats/payments-history`, { credentials: "include" })
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then(setData)
      .catch(() => setData({ items: [], by_year: {} }));
  }, []);

  if (!data || !data.items || data.items.length === 0) return null;
  const years = Object.keys(data.by_year || {}).sort().reverse();

  return (
    <div className="space-y-4 pt-4 border-t border-white/10" data-testid="payments-history">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold tracking-tight text-white flex items-center gap-2"><History className="w-5 h-5 text-[#C19A6B]" /> Historique des versements</h2>
          <p className="text-sm text-zinc-400 mt-0.5">Journal des rétrocommissions versées &amp; reçues — pour votre comptabilité annuelle.</p>
        </div>
        <div className="flex gap-2">
          <a href={`${API}/member/comandats/payments-history/export.csv`} data-testid="export-csv"
             className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-[#C19A6B] border border-[#C19A6B]/40 rounded-[5px] px-3 py-2 hover:bg-[#C19A6B]/10">
            <FileSpreadsheet className="w-3.5 h-3.5" /> Export CSV
          </a>
          <a href={`${API}/member/comandats/payments-history/export.pdf`} data-testid="export-pdf"
             className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-white bg-[#C19A6B] hover:bg-[#d1af84] rounded-[5px] px-3 py-2">
            <FileText className="w-3.5 h-3.5" /> Récap PDF
          </a>
        </div>
      </div>

      {/* Totaux par année */}
      <div className="flex flex-wrap gap-3" data-testid="payments-year-totals">
        {years.map((y) => (
          <div key={y} className="rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3" data-testid={`payments-year-${y}`}>
            <p className="text-[11px] uppercase tracking-wider text-zinc-500 mb-1">{y}</p>
            <div className="flex items-center gap-4 text-sm">
              <span className="inline-flex items-center gap-1 text-[#C19A6B]"><ArrowDownLeft className="w-3.5 h-3.5" /> Reçu {eur(data.by_year[y].recu)}</span>
              <span className="inline-flex items-center gap-1 text-zinc-300"><ArrowUpRight className="w-3.5 h-3.5" /> Versé {eur(data.by_year[y].verse)}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Journal */}
      <div className="rounded-xl border border-white/10 bg-white/[0.02] overflow-hidden divide-y divide-white/5" data-testid="payments-journal">
        {data.items.map((it, i) => {
          const recu = it.direction === "recu";
          return (
            <div key={i} data-testid={`payment-row-${i}`} className="flex items-center gap-3 px-4 py-3">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${recu ? "bg-[#C19A6B]/15 text-[#C19A6B]" : "bg-white/5 text-zinc-300"}`}>
                {recu ? <ArrowDownLeft className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4" />}
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-white text-sm font-medium truncate">{it.listing_title}</p>
                <p className="text-xs text-zinc-500 truncate">{fmtDate(it.paid_at)} · {recu ? "Reçu de" : "Versé à"} {it.counterparty}{it.city ? ` · ${it.city}` : ""}</p>
              </div>
              <div className="text-right shrink-0">
                <p className={`text-sm font-bold ${recu ? "text-[#C19A6B]" : "text-white"}`}>{recu ? "+" : "−"} {eur(it.amount)}</p>
                <p className="text-[10px] uppercase tracking-wider text-zinc-500">{recu ? "Reçu" : "Versé"}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
